// extracted by mini-css-extract-plugin
export default {"beef_product_img":"BeefSubprimal_beef_product_img__XGX2d","beef_product_img_container":"BeefSubprimal_beef_product_img_container__AiS8Y"};